module.exports = __webpack_public_path__ + "img/weibo-square.c7a1a849.svg";